import { render, staticRenderFns } from "./VillageMap.vue?vue&type=template&id=3c334d86&scoped=true"
import script from "./VillageMap.vue?vue&type=script&lang=js"
export * from "./VillageMap.vue?vue&type=script&lang=js"
import style0 from "./VillageMap.vue?vue&type=style&index=0&id=3c334d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c334d86",
  null
  
)

export default component.exports